var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("a-table", {
        key: "table-" + _vm.renderCount,
        staticClass: "custom-table",
        attrs: {
          columns: this.getCols(),
          dataSource: _vm.items(),
          locale: {
            emptyText: _vm.$t("message.noRePresentativeFound"),
          },
          pagination: false,
          rowKey: "_id",
          size: "small",
        },
        on: { change: _vm.tableChange },
        scopedSlots: _vm._u(
          [
            {
              key: "isOnlineSlot",
              fn: function (data, item) {
                return _c("div", { key: "isOnlineSlot-" + _vm.$i18n.locale }, [
                  "undefined" !== typeof item.isOnline && item.isOnline
                    ? _c(
                        "span",
                        {
                          class: _vm.statuses.find(function (s) {
                            return s.status === item.status
                          }).class,
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2",
                            attrs: {
                              icon: _vm.statuses.find(function (s) {
                                return s.status === item.status
                              }).icon,
                            },
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  _vm.statuses.find(function (s) {
                                    return s.status === item.status
                                  }).langKey
                                )
                              ) +
                              "\n            "
                          ),
                        ],
                        1
                      )
                    : _c(
                        "span",
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2",
                            attrs: { icon: "power-off" },
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("message.offline")) +
                              "\n            "
                          ),
                        ],
                        1
                      ),
                ])
              },
            },
            {
              key: "lastConnectionSlot".concat(this.renderCount),
              fn: function (data, item) {
                return _c(
                  "div",
                  {
                    key:
                      item._id +
                      "-lastConnectionSlot-" +
                      _vm.$i18n.locale +
                      "-" +
                      _vm.renderCount,
                  },
                  [
                    item.isOnline
                      ? _c("PassedTimeCounterTimeFormat", {
                          key: item._id + "-" + _vm.$i18n.locale,
                          attrs: {
                            id: item._id + "-" + _vm.$i18n.locale,
                            date: item.lastActivity,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !item.isOnline
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("dateShorted")(item.lastActivity))
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              },
            },
            {
              key: "lastUserAction".concat(this.renderCount),
              fn: function (data, item) {
                return _c(
                  "div",
                  {
                    key:
                      item._id +
                      "-lastUserAction-" +
                      _vm.$i18n.locale +
                      "-" +
                      _vm.renderCount,
                  },
                  [
                    item.lastStatusChangeDate
                      ? _c(
                          "div",
                          [
                            item.status === "Online"
                              ? _c("a-badge", { attrs: { color: "#1BC5BD" } })
                              : item.status === "Away"
                              ? _c("a-badge", { attrs: { color: "#3699FF" } })
                              : item.status === "Busy"
                              ? _c("a-badge", { attrs: { color: "#FFA829" } })
                              : _c("a-badge", { attrs: { color: "#F64E60" } }),
                            _vm._v(" "),
                            _c("PassedTimeCounterTimeFormat", {
                              key: item._id + "-" + _vm.$i18n.locale,
                              attrs: {
                                id: item._id + "-" + _vm.$i18n.locale,
                                date: new Date(
                                  item.lastStatusChangeDate
                                ).toISOString(),
                                "second-visible": false,
                                shortFormat: true,
                                suffix: _vm.$t("message.ago"),
                              },
                            }),
                          ],
                          1
                        )
                      : _c("span", [_vm._v("-")]),
                  ]
                )
              },
            },
            {
              key: "conversationCountSlot",
              fn: function (data, item) {
                return _c(
                  "div",
                  { key: "conversationCountSlot-" + _vm.$i18n.locale },
                  [
                    item.status === "Offline"
                      ? _c("span", [_vm._v("0 -")])
                      : _c("span", [
                          _vm._v(_vm._s(item.conversationCount || 0)),
                        ]),
                  ]
                )
              },
            },
            {
              key: "userMaxCapacitySlot",
              fn: function (data, item) {
                return _c(
                  "div",
                  { key: "userMaxCapacitySlot-" + _vm.$i18n.locale },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.getUserMaxChatCapacity(item._id))),
                    ]),
                  ]
                )
              },
            },
            {
              key: "actionSlot",
              fn: function (data, item) {
                return _c(
                  "div",
                  {
                    key: "actionSlot-" + _vm.$i18n.locale,
                    staticClass:
                      "d-flex justify-content-start align-items-center",
                  },
                  [
                    _vm.assign
                      ? _c(
                          "b-button",
                          {
                            attrs: { size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.assignAgent(item._id)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("message.addChat")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.forward
                      ? _c(
                          "b-button",
                          {
                            attrs: { size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.forwardAgent(item._id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("message.forwardChat")) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isRoot && _vm.infoButtonVisible
                      ? _c("a-icon", {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                                theme: _vm.isDarkMode
                                  ? "light-border"
                                  : "google",
                              },
                              expression:
                                "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                            },
                          ],
                          staticClass: "mr-2",
                          staticStyle: {
                            "font-size": "20px",
                            color: "#1bc5bd",
                            "background-color": "#ffffff",
                            "border-radius": "50%",
                          },
                          attrs: {
                            content: _vm.getUserDetailedLoginInfo(item),
                            theme: "filled",
                            type: "info-circle",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a-tooltip",
                      [
                        _c("template", { slot: "title" }, [
                          _vm._v(_vm._s(_vm.$t("report.reports"))),
                        ]),
                        _vm._v(" "),
                        _vm.reportButton
                          ? _c("a-icon", {
                              staticStyle: {
                                border: "1px solid #1bc5bd",
                                padding: "4px",
                                "box-sizing": "border-box",
                                "font-size": "12px",
                                color: "#1bc5bd",
                                "background-color": "#ffffff",
                                "border-radius": "50%",
                              },
                              attrs: { type: "line-chart" },
                              on: {
                                click: function ($event) {
                                  return _vm.goToReportsWithToday(item._id)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                )
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-end mt-3",
          staticStyle: { "margin-bottom": "60px" },
        },
        [
          _c("Pagination", {
            attrs: {
              "page-change": _vm.pageChange,
              "page-sizes": _vm.pageSizes,
              total: _vm.totalUserLength,
              pageSizeLocalStorageKey: "agent-list-page-size",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }